import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnTheFlyLocationOptionalFieldsMenu',
  props: {
    showCoordinatesField: { type: Boolean },
    showParentLocationField: { type: Boolean },
    showDescriptionField: { type: Boolean },
    showStatusField: { type: Boolean },
    showTagsField: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,VsButton }
}

})